<template>
    <Dialog header="Datos adicionales" :style="{width: '800px'}">  
        <div>
            <div class="card card-default card-tabs" style="margin-bottom: 0;">
                <div class="card-header p-1 pt-1">
                    <ul class="nav nav-pills" ref="tabHeaders">
                        <li v-for="(info, index) in Object.entries(adicionales)" :key="info[0]" class="nav-item">
                            <a class="nav-link" :href="'#'+info[0]" @click.prevent="cambiarTab(index)"
                            :class="{ 'active': index === activeTab }">
                                {{ info[0] }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <br>
            <div class="tab-content" ref="tabContents">
                <div v-for="(info, index) in Object.entries(adicionales)" :key="info[0]" class="tab-pane container-grid"
                    :id="info[0]" :class="{ 'active': index === activeTab }">  
                    <div class="container" style="display: grid;height:auto">
                        <div v-for="(campo, index2) in info[1]" :key="campo.id_campo" style="display: grid; grid-template-columns: 4fr 3fr; align-items: start; margin-bottom: 20px">
                            <label style="width: 100%; line-height: 1.2;" :for="'value_' + index" class="font-semibold">{{ campo.nombre_campo }}</label>
                            
                            <input v-model="respuestasCampos[index][index2]" v-if="campo.tipo_campo === 'texto'" style="height: 20px; font-size: 15px;" type="text" :id="'value_' + index"/>
    
                            <select style="height: 20px; font-size: 13px;" v-model="respuestasCampos[index][index2]" v-if="campo.tipo_campo === 'valores'"  placeholder="Selecciona un valor">
                                <option value="" selected>-----</option>
                                <option v-for="opcion in getValores(campo.valores_campo)"  :key="opcion" :value="opcion">{{ opcion }}</option>
                            </select>
    
                            <input v-model="respuestasCampos[index][index2]" v-if="campo.tipo_campo === 'numero'" style="height: 20px; font-size: 15px;" type="number" :id="'value_' + index"/>
    
                            <textarea v-model="respuestasCampos[index][index2]" style="font-size: 15px;" v-if="campo.tipo_campo === 'multilinea'" name="tt" rows="2" cols="30" :id="'value_' + index"></textarea>
    
                            <Editor v-model="respuestasCampos[index][index2]" v-if="campo.tipo_campo === 'formateado'" editorStyle="height: 80px" :id="'value_' + index"/>
    
                            <label v-if="campo.tipo_campo === 'formula'" :id="'value_' + index">{{ respuestasCampos[index][index2] }}</label>
                        </div>
                    </div> 
                </div>
            </div>
            <div style="display: flex; border-top: 1px solid grey; margin-top: 10px; justify-content: end;">
                <button class="btn btn-light btn-sm" style="border: 1px solid; margin-top: 15px;" @click="guardarDatos">Guardar</button>
            </div>       
        </div>
    </Dialog>
</template>

<script>
import { PwgsApi } from '../../../../../services/PwgsApi';
import Dialog from 'primevue/dialog';
import $ from 'jquery'; // Asegúrate de tener jQuery disponible
import Editor from 'primevue/editor';
export default {
    props: ['idservicio', 'idvisita', 'visita'],
    components: {
        Dialog,
        Editor,
    },
    data() {
        return {
            adicionales: [],
            valoresPorDefecto: {},
            activeTab: 0, // Índice de la pestaña activa
            respuestas: [],
            respuestasCampos:[[]],
        };
    },
    mounted() {
        this.cargarAdicionales();
    },
    methods: {
        async cargarAdicionales() {
            const api = new PwgsApi();
            const resp = await api.get('servicios/' + this.idservicio + '/gestion-doc?tipo=visitadores');
            this.adicionales = resp.datos_adicionales.visitadores;
            this.rellenarRespuestas();
            // Asegúrate de activar la primera pestaña al cargar los datos
            this.$nextTick(() => {
                this.activarPrimerTab();
            });
        },
        cambiarTab(index) {
            this.activeTab = index;
            this.$nextTick(() => {
                this.mostrarTab(index);
            });
        },
        getValores(serialized){
            const regex = /i:\d+;s:\d+:"(.*?)";/g;
            let match;
            const result = [];

            // Usar un bucle para encontrar todas las coincidencias y extraer los valores
            while ((match = regex.exec(serialized)) !== null) {
                result.push(match[1] );
            }
            return result;
        },
        rellenarRespuestas() {
            this.respuestas = this.visita.datos_adicionales;
            if (!this.respuestas) {
                // Inicializa respuestasCampos con la misma longitud que las claves de adicionales, cada uno con un sub-array vacío.
                this.respuestasCampos = Object.keys(this.adicionales).map(() => []);  

                // Rellena el array bidimensional con strings vacíos.
                Object.entries(this.adicionales).forEach(([key, campos], i) => {
                    console.log(key);
                    this.respuestasCampos[i] = campos.map(() => "");  // Rellenar cada campo con un string vacío.
                });
            } else {
                this.respuestasCampos = Object.keys(this.adicionales).map(() => []);  // Inicializa el array bidimensional

                var ids = Object.keys(this.adicionales);  // Obtén las claves de los adicionales.
                for (var ii = 0; ii < ids.length; ii++) {
                    var idDato = ids[ii];
                    var campos = this.adicionales[idDato];
                    
                    // Usa map para recorrer cada campo y asignar la respuesta correspondiente.
                    this.respuestasCampos[ii] = campos.map((campo, jj) => {
                        console.log(jj);
                        const id = campo.id_campo;
                        return this.respuestas[id] ? this.respuestas[id].valor_campo : "";  // Asigna la respuesta o un string vacío.
                    });
                }
            }
        },

        mostrarTab(index) {
            // Usa refs para asegurarte de que solo estás afectando los elementos de este componente
            const $tabs = $(this.$refs.tabHeaders).find('.nav-link');
            const $panes = $(this.$refs.tabContents).find('.tab-pane');

            $tabs.removeClass('active').eq(index).addClass('active');
            $panes.removeClass('active').eq(index).addClass('active');
        },
        activarPrimerTab() {
            this.mostrarTab(this.activeTab);
        },
        async guardarDatos(){
            const api = new PwgsApi();
            var i = 0;
            for(let adicional of Object.entries(this.adicionales)){
                for(var j in adicional[1]){
                    var id = adicional[1][j].id_campo;
                    var valor = this.respuestasCampos[i][j];
                    var body = {'seccion': 'visitadores', 'id_seccion':this.idvisita, 'id_campo':id, 'valor_campo':valor};
                    await api.put('servicios/' + this.idservicio + '/campos', body);
                }
                i++;
            }
            this.$toast.add({ severity: 'success', summary: 'Guardado', detail: 'Datos guardados correctamente', life: 2000 });
        },
    },
    watch: {
        idservicio() {
            this.valoresPorDefecto = {};
            this.adicionales = [];
            this.cargarAdicionales();
        },
    },
};
</script>

<style scoped>
.container{
    display: grid;
    overflow: auto;
    height: 600px;
}
.form{
    margin-bottom: 30px;
}
.form label {
    display: block;
    margin-bottom: 8px;
    font-weight: bold; 
}

.form textarea {
    display: block;
    width: 100%;
    max-width: 100%;
    margin-bottom: 8px;
    box-sizing: border-box;
}
.form editor{
    display: block;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    margin-bottom: 8px;
}

.form select{
    display: block;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;    
}

.form input{
    display: block;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
}
.btns{
    display: flex;
    justify-content: end;
    gap:15px;
    padding-bottom: 10px;
}
.btn-size:hover{
    background-color:rgb(163, 163, 163);
}
</style>